import React from 'react'
import styled from 'styled-components'
import {lightGray, seaNavy} from '@modifi/colors'
import {media} from '@modifi/ui'
import SwipeableContainer from './components/swipeable-contaienr'

export const CarouselContainer = styled(SwipeableContainer)`
  padding-bottom: 16px;
`

export const CardWrapper = React.memo(styled.div`
  display: inline-block;
`)

type IndicatorsProps = {
  position: 'left' | 'right' | 'center'
}

export const Indicators = styled.div<IndicatorsProps>`
  display: flex;
  justify-content: center;
  ${media.min.xs<IndicatorsProps>`
    justify-content: ${({position}): string =>
      (position === 'left' && 'flex-start') || (position === 'right' && 'flex-end') || 'center'}
  `}
  & > button {
    margin: 5px;
    border-radius: 50%;
    background-color: ${lightGray};
    width: 10px;
    height: 10px;
    border: none;
    cursor: pointer;
    transition: width 0.3s linear;

    &[data-isactive='true'] {
      background-color: ${seaNavy};
      width: 20px;
      border-radius: 10px;
    }
  }
`
